<template>
  <div class="two-box">
    <div class="two-top">
      <div class="two-top-left">
        <h1>技术服务</h1>
        <span>TECHNICAL SERVICE</span>
      </div>
      <div class="two-top-right">
        <img src="../../../images/mores.png" alt="" />
        <a  @click="goxq()">查看更多</a>
      </div>
    </div>
    <div class="two-bottom">
      <div class="two-bottom-left" @click="goxq(item.id)"
          v-for="(item, index) in list"
          :key="index"
          :class="index === currentIndex ? 'active' : ''"
          @mouseenter="mouseOver(index)"
          @mouseleave="mouseLeave(index)"
          v-if="index == 0"
        >
        <img class="animal" :src="item.recommend_image" alt="" />
        <h1>{{ item.name }}</h1>
        <div class="animal-a">
          <a href="javascript:;">了解更多</a>
          <img class="you" src="../../../images/right.png" alt="" />
        </div>
      </div>
      <div class="two-bottom-right">
        <dl
          @click="goxq(item.id)"
          v-for="(item, index) in list"
          :key="index"
          :class="index === currentIndex ? 'active' : ''"
          @mouseenter="mouseOver(index)"
          @mouseleave="mouseLeave(index)"
          v-if="index !== 0"
        >
        <img :src="item.recommend_image" alt="" />
        <!-- <p>{{ item.name }}</p> -->
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: "",
      list: []
    };
  },
  methods: {
    mouseOver(index) {
      this.currentIndex = index;
    },
    mouseLeave(index) {
      this.currentIndex = "";
    },
    goxq(id){
      this.$router.push({path:'/technicalService',query:{id}})
    }
  },
  created() {
     this.$api.homepage.service().then(res=>{
        this.list=res.data
    })
  },
};
</script>

<style lang="less" scoped>
.two-box {
  width: 1250px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  .two-top {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 68px;
    .two-top-left {
      h1 {
        font-size: 28px;
        font-weight: 700;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 20px;
        text-align: left;
        color: #b8b8b8;
        line-height: 41px;
      }
    }
    .two-top-right {
      a {
        font-size: 16px;
        color: #999999;
        line-height: 19px;
        margin-left: 5px;
      }
    }
  }
  .two-bottom {
    flex: 3;
    display: flex;
    margin-top: 62px;
    .two-bottom-left {
      width: 290px;
      height: 446px;
      background: #003871;
      border-radius: 2px;
      .animal {
        width: 134px;
        height: 134px;
        margin-top: 73px;
        margin-left: 74px;;
      }
      .animal-a{
        a{
          font-weight: 600;
          font-size: 16px;
          margin-top: -2px;
        }
        img{
           margin-left: 5px;
        }
      }
      h1 {
        font-size: 28px;
        text-align: left;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: center;
        margin-top: 75px;
      }
      div {
        width: 135px;
        height: 37px;
        background: #f7b500;
        margin: auto;
        margin-top: 34px;
        position: relative;
        a {
          font-size: 14px;
          color: #003871;
          letter-spacing: 1px;
          position: absolute;
          left: 26px;
          top: 8px;
        }
        img {
          position: absolute;
          left: 93px;
          top: 14px;
        }
      }
    }
    .two-bottom-right {
      height: 446px;
      width: 990px;
      margin-top: -20px;
      display: grid;
      padding-left: 18px;
      grid-template-columns: repeat(3, 333px);
      grid-template-rows: 244px 244px;
      img {
        width: 100%;
        height: 100%;
      }
      .active {
        border: 1px solid #f7b500;
        cursor: pointer;
        width: 322px;
        height: 234px;
      }
      dl {
        margin: auto;
        width: 292px;
        height: 212px;
        background: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 11px 0px rgba(193, 193, 193, 0.5);
        text-align: center;
        // position: relative;
      }
      // p{
      //    position: absolute;
      //    left:0px;
      //    bottom:0px;
      //    background: #fbbb0a;
      //    width: 100%;
      //    height:32px;
      //    font-size:16px;
      //    line-height: 32px;
      //    font-weight: 700;
      //    color: #fff;
      // }
    }
  }
}
</style>